import AbcCliente from './AbcCliente';

export default AbcCliente;